<div class="log-info-box">
    <div class="d-block">
        <cm-running-message *ngIf="runningMessages" [runningMessages]="runningMessages"
            class="running-message-wrapper"></cm-running-message>
    </div>

    <div class="login-befor mt-3" [ngClass]="{'': auth.isAuthenticated(), 'show': !auth.isAuthenticated()}">
        <a class="btn-top login-btn" tabindex="4" (click)="auth.toggleLoginDisplay(true)">
            <span class="i18n" data-tag="login">{{
                'accounts.login.login' | translate
                }}</span>
        </a>
        <button
          *ngIf="!this.auth.testGame"
          class="btn-top testgame-btn"
          tabindex="4"
          (click)="triggerAnimation(true)"
        >
          <span class="i18n" data-tag="login">{{
            'accounts.test_game.free' | translate
          }}</span>
        </button>
        <a *ngIf="showAnimation && this.auth.testGame" class="btn-top login-btn" tabindex="4" (click)="triggerAnimation(false)">
            <span class="i18n" data-tag="login">{{
                'accounts.test_game.demo' | translate
                }}</span>
        </a>
    </div>

    <div class="login-after mt-3" [ngClass]="{'show': auth.isAuthenticated(), '': !auth.isAuthenticated()}">
        <div class="info-left">
            <div class="info-money">
                <a class="account" href="javascript:void(0)"></a>
                <span class="icon-welcome"><img src="../../../../assets/images/log-info/welcome.png"></span>
            </div>
            <div class="info-account">
                <span class="balance money me-2">{{creditBalance | decimalFormat: 2}}</span>
                <i class="fa fa-refresh" (click)="refreshBalance()"></i>
            </div>
        </div>
        <div class="info-right">
            <!-- <div class="info-box" (click)="showReportDialog()"> -->
            <div class="info-box" routerLink="/contents/pages/report">
                <span class="icon icon-info"><img src="../../../../assets/images/log-info/bil.png"></span>
                <em class="i18n" data-tag="report">{{ 'contents.log-info.report' | translate }}</em>
            </div>
            <div class="info-box" (click)="showChangePasswordDialog()">
                <span class="icon icon-info"><img src="../../../../assets/images/log-info/password.png"></span>
                <em class="i18n" data-tag="changePassword">{{ 'contents.log-info.password' | translate }}</em>
            </div>
            <div class="info-box" (click)="logout()">
                <span class="icon icon-info"><img src="../../../../assets/images/log-info/out.png"></span>
                <a class="i18n" data-tag="logout">{{ 'contents.log-info.logout' | translate }}</a>
            </div>
        </div>
    </div>
</div>